import React, { useState } from 'react';
import type { ReactNode } from 'react';
import { ErrorContext, type ErrorContextType } from './ErrorContextDefinition';
import apiService from '../services/api';

interface ErrorProviderProps {
  children: ReactNode;
}

export const ErrorProvider: React.FC<ErrorProviderProps> = ({ children }) => {
  const [errorInfo, setErrorInfo] = useState<ErrorContextType['errorInfo']>(null);

  const setError = (newErrorInfo: ErrorContextType['errorInfo']) => {
    console.log('🔴 ErrorContext - Setting error:', newErrorInfo);
    setErrorInfo(newErrorInfo);
  };

  const clearError = () => {
    console.log('🟢 ErrorContext - Clearing error');
    setErrorInfo(null);
  };

  const retryLastRequest = async () => {
    if (errorInfo?.retryAction) {
      console.log('🔄 ErrorContext - Retrying last request');
      try {
        await errorInfo.retryAction();
        clearError();
      } catch (error) {
        console.error('❌ ErrorContext - Retry failed:', error);
        throw error;
      }
    } else if (errorInfo?.requestConfig) {
      console.log('🔄 ErrorContext - Retrying last request via stored config');
      try {
        const axiosInstance = apiService.getAxiosInstance();
        await axiosInstance.request(errorInfo.requestConfig);
        clearError();
      } catch (error) {
        console.error('❌ ErrorContext - Retry via stored config failed:', error);
        throw error;
      }
    } else {
      console.warn('⚠️ ErrorContext - No retry action available');
      throw new Error('No retry action available');
    }
  };

  return (
    <ErrorContext.Provider 
      value={{ 
        errorInfo, 
        setError, 
        clearError, 
        retryLastRequest 
      }}
    >
      {children}
    </ErrorContext.Provider>
  );
};
